const isGCXDomain = () => {
  const currentUrl = window.location.hostname;
  return !!currentUrl.match(/gcx.raise/);
};

const handleChatWidget = () => {
  window.duet && window.duet.open();
  window.zE && window.zE('messenger', 'open');
}

export { isGCXDomain, handleChatWidget }
